import {Component, Input, OnInit} from '@angular/core';
import {ILayoutSettings, IPageContent} from '@app/feature/store-editor/components/layout/store-editor.interface';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {CommonService} from '@app/feature/store-editor/services/common.service';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.css']
})
export class VideoComponent implements OnInit {

  @Input() item: IPageContent;
  @Input() layoutSetting: ILayoutSettings;
  link: SafeUrl;
  constructor(private sanitizer: DomSanitizer, private cs: CommonService) { }

  ngOnInit() {
    this.link = this.createLink();
    this.cs.updateDesignOb().subscribe((res) => {

      this.link = this.createLink();
    });
  }

  createLink() {
    let args = '';
    // tslint:disable-next-line:forin
    for (const key in this.item.data.playerSetting) {
      // @ts-ignore
      if (typeof this.item.data.playerSetting[key] === 'boolean') {
        // @ts-ignore
        args += key + '=' + (this.item.data.playerSetting[key] ? '1' : '0') + '&';
      } else {
        // @ts-ignore
        args += key + '=' + this.item.data.playerSetting[key] + '&';
      }
    }
 
    const link = 'https://www.youtube.com/embed/' + this.item.data.link + '?' + args;

    return this.sanitizer.bypassSecurityTrustResourceUrl(link);
  }

}
